// extracted by mini-css-extract-plugin
module.exports = {"total":"AnnualCapitalFund_total__3ehnn","tableContent":"AnnualCapitalFund_tableContent__3rekK"};